window.axios = require('axios');


let language = document.head.querySelector('meta[name="_lang"]');
window.siteLanguage = language.content;

let token = document.head.querySelector('meta[name="_token"]');
window.CSRFToken = token.content;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

import Vue from 'vue';
window.Vue = Vue;
Vue.prototype.$http = window.axios;

Vue.component('menu-main', require('vueComponents/MenuMain.vue').default);

require('font-awesome/scss/font-awesome.scss');
require('./bootstrap');
require('./custom');
require('./slider-main');
require('./base64.js'); 
//require('./googleMapsV3.js');

